import React from 'react'
// components
import Report from 'components/PageComponents/DataHub/Report/New'

const ReportCreatePage: React.FC = () => <Report />

export default ReportCreatePage
